import { render, staticRenderFns } from "./area-rank.vue?vue&type=template&id=b90c9c96&"
import script from "./area-rank.vue?vue&type=script&lang=js&"
export * from "./area-rank.vue?vue&type=script&lang=js&"
import style0 from "./area-rank.vue?vue&type=style&index=0&id=b90c9c96&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports